import { render, staticRenderFns } from "./MemorialAltar.vue?vue&type=template&id=78fef134&scoped=true"
import script from "./MemorialAltar.vue?vue&type=script&lang=js"
export * from "./MemorialAltar.vue?vue&type=script&lang=js"
import style0 from "./MemorialAltar.vue?vue&type=style&index=0&id=78fef134&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fef134",
  null
  
)

export default component.exports